import RequireSuperAdminMiddleware from 'middlewares/RequireSuperAdminMiddleware'

const middlewares = [RequireSuperAdminMiddleware]

export default [
    {
        path: '/intelligence',
        name: 'intelligence',
        redirect: { name: 'intelligence.overview' },
    },
    {
        path: '/intelligence/overview',
        name: 'intelligence.overview',
        view: 'intelligence/Overview',
        middlewares,
    },
    {
        path: '/intelligence/constraints',
        name: 'intelligence.constraints',
        view: 'intelligence/Constraints',
        middlewares,
    },
]
